<template>
  <CollectionFilterModule 
    v-for="(value, name) in filters" 
    :key="name" 
    :filter-type="name"
    :filter-options="value" 
    :applied-filters="appliedFilters[name]"
    @input-change="filterChange"
  />
</template>

<script setup>
  import { toRefs, computed, ref, watch } from 'vue';
  import CollectionFilterModule from './collection-filter-module.vue';

  const props = defineProps({
    filteredProducts: {
      type: Array,
      required: true,
    },

    currentFilter: {
      type: String,
      required: true,
    },

    appliedFilters: {
      type: Object,
      required: true,
    },

    appliedFiltersCount: {
      type: Object,
      required: true,
    }
  })

  const { filteredProducts, currentFilter } = toRefs(props)
  const emit = defineEmits(['on-filter-change', 'on-filters-update'])

  const baseFilters = computed(() => {
    const filterType = { category: {}, benefit: {}, type: {} };

    filteredProducts.value.forEach(product => {
      if (product.product_type === 'card') return;

      product.tags.forEach(tag => {
        const [prefix, keyName] = tag.split(':').map(part => part.trim());
        if (prefix === 'Category') {
          filterType.category[keyName] = (filterType.category[keyName] || 0) + 1;
        } else if (prefix === 'Benefit') {
          filterType.benefit[keyName] = (filterType.benefit[keyName] || 0) + 1;
        } else if (prefix === 'Type') {
          filterType.type[keyName] = (filterType.type[keyName] || 0) + 1;
        }
      });
    });

    return filterType;
  });

  const cacheFilters = ref({ ...baseFilters.value });

  const filters = computed(() => {
    const base = baseFilters.value;
    const cache = cacheFilters.value;
    cacheFilters.value = { ...base };

    switch (currentFilter.value) {
      case 'category':
        cacheFilters.value.category = Object.values(cacheFilters.value.category).length ? cache.category : base.category;
        return { ...base, category: cacheFilters.value.category };
      case 'benefit':
        cacheFilters.value.benefit = Object.values(cacheFilters.value.benefit).length ? cache.benefit : base.benefit;
        return { ...base, benefit: cacheFilters.value.benefit };
      case 'type':
        cacheFilters.value.type = Object.values(cacheFilters.value.type).length ? cache.type : base.type;
        return { ...base, type: cacheFilters.value.type };
      default:
        return base;
    }
  });

  const filterChange = (filterKey, options) => {
    emit('on-filter-change', filterKey, options)
  }

  watch(baseFilters, () => {
    if (!currentFilter.value) {
      cacheFilters.value = { ...baseFilters.value };
    }
  }, { deep: true });

  watch(filters, (newFilters) => {
    emit('on-filters-update', newFilters); 
  }, { immediate: true,deep: true });
</script>